// source: core/protos/measurement.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var core_protos_aws_pb = require('../../core/protos/aws_pb.js');
goog.object.extend(proto, core_protos_aws_pb);
var core_protos_uuid_pb = require('../../core/protos/uuid_pb.js');
goog.object.extend(proto, core_protos_uuid_pb);
var core_protos_geometry_pb = require('../../core/protos/geometry_pb.js');
goog.object.extend(proto, core_protos_geometry_pb);
goog.exportSymbol('proto.vertexvis.protobuf.core.CircleResult', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.EllipseResult', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.LengthResult', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.MeasurementOutcome', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.MeasurementResult', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.MeasurementResult.DetailsCase', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.MinimumDistanceResult', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.PlanarAngleResult', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.PlanarDistanceResult', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.PlanePair', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.SurfaceAreaResult', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.PlanePair = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.PlanePair, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.PlanePair.displayName = 'proto.vertexvis.protobuf.core.PlanePair';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.PlanarDistanceResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.PlanarDistanceResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.PlanarDistanceResult.displayName = 'proto.vertexvis.protobuf.core.PlanarDistanceResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.MinimumDistanceResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.MinimumDistanceResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.MinimumDistanceResult.displayName = 'proto.vertexvis.protobuf.core.MinimumDistanceResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.PlanarAngleResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.PlanarAngleResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.PlanarAngleResult.displayName = 'proto.vertexvis.protobuf.core.PlanarAngleResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.SurfaceAreaResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.SurfaceAreaResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.SurfaceAreaResult.displayName = 'proto.vertexvis.protobuf.core.SurfaceAreaResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.LengthResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.LengthResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.LengthResult.displayName = 'proto.vertexvis.protobuf.core.LengthResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.CircleResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.CircleResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.CircleResult.displayName = 'proto.vertexvis.protobuf.core.CircleResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.EllipseResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.EllipseResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.EllipseResult.displayName = 'proto.vertexvis.protobuf.core.EllipseResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.MeasurementResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.vertexvis.protobuf.core.MeasurementResult.oneofGroups_);
};
goog.inherits(proto.vertexvis.protobuf.core.MeasurementResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.MeasurementResult.displayName = 'proto.vertexvis.protobuf.core.MeasurementResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.MeasurementOutcome = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vertexvis.protobuf.core.MeasurementOutcome.repeatedFields_, null);
};
goog.inherits(proto.vertexvis.protobuf.core.MeasurementOutcome, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.MeasurementOutcome.displayName = 'proto.vertexvis.protobuf.core.MeasurementOutcome';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.PlanePair.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.PlanePair.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.PlanePair} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.PlanePair.toObject = function(includeInstance, msg) {
  var f, obj = {
    start: (f = msg.getStart()) && core_protos_geometry_pb.Plane.toObject(includeInstance, f),
    end: (f = msg.getEnd()) && core_protos_geometry_pb.Plane.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.PlanePair}
 */
proto.vertexvis.protobuf.core.PlanePair.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.PlanePair;
  return proto.vertexvis.protobuf.core.PlanePair.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.PlanePair} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.PlanePair}
 */
proto.vertexvis.protobuf.core.PlanePair.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_geometry_pb.Plane;
      reader.readMessage(value,core_protos_geometry_pb.Plane.deserializeBinaryFromReader);
      msg.setStart(value);
      break;
    case 2:
      var value = new core_protos_geometry_pb.Plane;
      reader.readMessage(value,core_protos_geometry_pb.Plane.deserializeBinaryFromReader);
      msg.setEnd(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.PlanePair.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.PlanePair.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.PlanePair} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.PlanePair.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStart();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_geometry_pb.Plane.serializeBinaryToWriter
    );
  }
  f = message.getEnd();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      core_protos_geometry_pb.Plane.serializeBinaryToWriter
    );
  }
};


/**
 * optional Plane start = 1;
 * @return {?proto.vertexvis.protobuf.core.Plane}
 */
proto.vertexvis.protobuf.core.PlanePair.prototype.getStart = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Plane} */ (
    jspb.Message.getWrapperField(this, core_protos_geometry_pb.Plane, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Plane|undefined} value
 * @return {!proto.vertexvis.protobuf.core.PlanePair} returns this
*/
proto.vertexvis.protobuf.core.PlanePair.prototype.setStart = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.PlanePair} returns this
 */
proto.vertexvis.protobuf.core.PlanePair.prototype.clearStart = function() {
  return this.setStart(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.PlanePair.prototype.hasStart = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Plane end = 2;
 * @return {?proto.vertexvis.protobuf.core.Plane}
 */
proto.vertexvis.protobuf.core.PlanePair.prototype.getEnd = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Plane} */ (
    jspb.Message.getWrapperField(this, core_protos_geometry_pb.Plane, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Plane|undefined} value
 * @return {!proto.vertexvis.protobuf.core.PlanePair} returns this
*/
proto.vertexvis.protobuf.core.PlanePair.prototype.setEnd = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.PlanePair} returns this
 */
proto.vertexvis.protobuf.core.PlanePair.prototype.clearEnd = function() {
  return this.setEnd(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.PlanePair.prototype.hasEnd = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.PlanarDistanceResult.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.PlanarDistanceResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.PlanarDistanceResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.PlanarDistanceResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    distance: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    planes: (f = msg.getPlanes()) && proto.vertexvis.protobuf.core.PlanePair.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.PlanarDistanceResult}
 */
proto.vertexvis.protobuf.core.PlanarDistanceResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.PlanarDistanceResult;
  return proto.vertexvis.protobuf.core.PlanarDistanceResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.PlanarDistanceResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.PlanarDistanceResult}
 */
proto.vertexvis.protobuf.core.PlanarDistanceResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDistance(value);
      break;
    case 2:
      var value = new proto.vertexvis.protobuf.core.PlanePair;
      reader.readMessage(value,proto.vertexvis.protobuf.core.PlanePair.deserializeBinaryFromReader);
      msg.setPlanes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.PlanarDistanceResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.PlanarDistanceResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.PlanarDistanceResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.PlanarDistanceResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDistance();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getPlanes();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vertexvis.protobuf.core.PlanePair.serializeBinaryToWriter
    );
  }
};


/**
 * optional double distance = 1;
 * @return {number}
 */
proto.vertexvis.protobuf.core.PlanarDistanceResult.prototype.getDistance = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.PlanarDistanceResult} returns this
 */
proto.vertexvis.protobuf.core.PlanarDistanceResult.prototype.setDistance = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional PlanePair planes = 2;
 * @return {?proto.vertexvis.protobuf.core.PlanePair}
 */
proto.vertexvis.protobuf.core.PlanarDistanceResult.prototype.getPlanes = function() {
  return /** @type{?proto.vertexvis.protobuf.core.PlanePair} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.PlanePair, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.PlanePair|undefined} value
 * @return {!proto.vertexvis.protobuf.core.PlanarDistanceResult} returns this
*/
proto.vertexvis.protobuf.core.PlanarDistanceResult.prototype.setPlanes = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.PlanarDistanceResult} returns this
 */
proto.vertexvis.protobuf.core.PlanarDistanceResult.prototype.clearPlanes = function() {
  return this.setPlanes(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.PlanarDistanceResult.prototype.hasPlanes = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.MinimumDistanceResult.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.MinimumDistanceResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.MinimumDistanceResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.MinimumDistanceResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    distance: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    closestPoint1: (f = msg.getClosestPoint1()) && core_protos_geometry_pb.Vector3d.toObject(includeInstance, f),
    closestPoint2: (f = msg.getClosestPoint2()) && core_protos_geometry_pb.Vector3d.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.MinimumDistanceResult}
 */
proto.vertexvis.protobuf.core.MinimumDistanceResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.MinimumDistanceResult;
  return proto.vertexvis.protobuf.core.MinimumDistanceResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.MinimumDistanceResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.MinimumDistanceResult}
 */
proto.vertexvis.protobuf.core.MinimumDistanceResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDistance(value);
      break;
    case 2:
      var value = new core_protos_geometry_pb.Vector3d;
      reader.readMessage(value,core_protos_geometry_pb.Vector3d.deserializeBinaryFromReader);
      msg.setClosestPoint1(value);
      break;
    case 3:
      var value = new core_protos_geometry_pb.Vector3d;
      reader.readMessage(value,core_protos_geometry_pb.Vector3d.deserializeBinaryFromReader);
      msg.setClosestPoint2(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.MinimumDistanceResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.MinimumDistanceResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.MinimumDistanceResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.MinimumDistanceResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDistance();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getClosestPoint1();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      core_protos_geometry_pb.Vector3d.serializeBinaryToWriter
    );
  }
  f = message.getClosestPoint2();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      core_protos_geometry_pb.Vector3d.serializeBinaryToWriter
    );
  }
};


/**
 * optional double distance = 1;
 * @return {number}
 */
proto.vertexvis.protobuf.core.MinimumDistanceResult.prototype.getDistance = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.MinimumDistanceResult} returns this
 */
proto.vertexvis.protobuf.core.MinimumDistanceResult.prototype.setDistance = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional Vector3d closest_point_1 = 2;
 * @return {?proto.vertexvis.protobuf.core.Vector3d}
 */
proto.vertexvis.protobuf.core.MinimumDistanceResult.prototype.getClosestPoint1 = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3d} */ (
    jspb.Message.getWrapperField(this, core_protos_geometry_pb.Vector3d, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.MinimumDistanceResult} returns this
*/
proto.vertexvis.protobuf.core.MinimumDistanceResult.prototype.setClosestPoint1 = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.MinimumDistanceResult} returns this
 */
proto.vertexvis.protobuf.core.MinimumDistanceResult.prototype.clearClosestPoint1 = function() {
  return this.setClosestPoint1(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.MinimumDistanceResult.prototype.hasClosestPoint1 = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Vector3d closest_point_2 = 3;
 * @return {?proto.vertexvis.protobuf.core.Vector3d}
 */
proto.vertexvis.protobuf.core.MinimumDistanceResult.prototype.getClosestPoint2 = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3d} */ (
    jspb.Message.getWrapperField(this, core_protos_geometry_pb.Vector3d, 3));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.MinimumDistanceResult} returns this
*/
proto.vertexvis.protobuf.core.MinimumDistanceResult.prototype.setClosestPoint2 = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.MinimumDistanceResult} returns this
 */
proto.vertexvis.protobuf.core.MinimumDistanceResult.prototype.clearClosestPoint2 = function() {
  return this.setClosestPoint2(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.MinimumDistanceResult.prototype.hasClosestPoint2 = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.PlanarAngleResult.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.PlanarAngleResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.PlanarAngleResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.PlanarAngleResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    angleInRadians: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    planes: (f = msg.getPlanes()) && proto.vertexvis.protobuf.core.PlanePair.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.PlanarAngleResult}
 */
proto.vertexvis.protobuf.core.PlanarAngleResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.PlanarAngleResult;
  return proto.vertexvis.protobuf.core.PlanarAngleResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.PlanarAngleResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.PlanarAngleResult}
 */
proto.vertexvis.protobuf.core.PlanarAngleResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAngleInRadians(value);
      break;
    case 5:
      var value = new proto.vertexvis.protobuf.core.PlanePair;
      reader.readMessage(value,proto.vertexvis.protobuf.core.PlanePair.deserializeBinaryFromReader);
      msg.setPlanes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.PlanarAngleResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.PlanarAngleResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.PlanarAngleResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.PlanarAngleResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAngleInRadians();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getPlanes();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.vertexvis.protobuf.core.PlanePair.serializeBinaryToWriter
    );
  }
};


/**
 * optional double angle_in_radians = 1;
 * @return {number}
 */
proto.vertexvis.protobuf.core.PlanarAngleResult.prototype.getAngleInRadians = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.PlanarAngleResult} returns this
 */
proto.vertexvis.protobuf.core.PlanarAngleResult.prototype.setAngleInRadians = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional PlanePair planes = 5;
 * @return {?proto.vertexvis.protobuf.core.PlanePair}
 */
proto.vertexvis.protobuf.core.PlanarAngleResult.prototype.getPlanes = function() {
  return /** @type{?proto.vertexvis.protobuf.core.PlanePair} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.PlanePair, 5));
};


/**
 * @param {?proto.vertexvis.protobuf.core.PlanePair|undefined} value
 * @return {!proto.vertexvis.protobuf.core.PlanarAngleResult} returns this
*/
proto.vertexvis.protobuf.core.PlanarAngleResult.prototype.setPlanes = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.PlanarAngleResult} returns this
 */
proto.vertexvis.protobuf.core.PlanarAngleResult.prototype.clearPlanes = function() {
  return this.setPlanes(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.PlanarAngleResult.prototype.hasPlanes = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.SurfaceAreaResult.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.SurfaceAreaResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.SurfaceAreaResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.SurfaceAreaResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    area: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.SurfaceAreaResult}
 */
proto.vertexvis.protobuf.core.SurfaceAreaResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.SurfaceAreaResult;
  return proto.vertexvis.protobuf.core.SurfaceAreaResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.SurfaceAreaResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.SurfaceAreaResult}
 */
proto.vertexvis.protobuf.core.SurfaceAreaResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setArea(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.SurfaceAreaResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.SurfaceAreaResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.SurfaceAreaResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.SurfaceAreaResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArea();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
};


/**
 * optional double area = 1;
 * @return {number}
 */
proto.vertexvis.protobuf.core.SurfaceAreaResult.prototype.getArea = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.SurfaceAreaResult} returns this
 */
proto.vertexvis.protobuf.core.SurfaceAreaResult.prototype.setArea = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.LengthResult.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.LengthResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.LengthResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.LengthResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    length: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.LengthResult}
 */
proto.vertexvis.protobuf.core.LengthResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.LengthResult;
  return proto.vertexvis.protobuf.core.LengthResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.LengthResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.LengthResult}
 */
proto.vertexvis.protobuf.core.LengthResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLength(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.LengthResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.LengthResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.LengthResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.LengthResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLength();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
};


/**
 * optional double length = 1;
 * @return {number}
 */
proto.vertexvis.protobuf.core.LengthResult.prototype.getLength = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.LengthResult} returns this
 */
proto.vertexvis.protobuf.core.LengthResult.prototype.setLength = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.CircleResult.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.CircleResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.CircleResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.CircleResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    radius: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    center: (f = msg.getCenter()) && core_protos_geometry_pb.Vector3d.toObject(includeInstance, f),
    axis: (f = msg.getAxis()) && core_protos_geometry_pb.Vector3d.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.CircleResult}
 */
proto.vertexvis.protobuf.core.CircleResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.CircleResult;
  return proto.vertexvis.protobuf.core.CircleResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.CircleResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.CircleResult}
 */
proto.vertexvis.protobuf.core.CircleResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRadius(value);
      break;
    case 2:
      var value = new core_protos_geometry_pb.Vector3d;
      reader.readMessage(value,core_protos_geometry_pb.Vector3d.deserializeBinaryFromReader);
      msg.setCenter(value);
      break;
    case 3:
      var value = new core_protos_geometry_pb.Vector3d;
      reader.readMessage(value,core_protos_geometry_pb.Vector3d.deserializeBinaryFromReader);
      msg.setAxis(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.CircleResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.CircleResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.CircleResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.CircleResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRadius();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getCenter();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      core_protos_geometry_pb.Vector3d.serializeBinaryToWriter
    );
  }
  f = message.getAxis();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      core_protos_geometry_pb.Vector3d.serializeBinaryToWriter
    );
  }
};


/**
 * optional double radius = 1;
 * @return {number}
 */
proto.vertexvis.protobuf.core.CircleResult.prototype.getRadius = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.CircleResult} returns this
 */
proto.vertexvis.protobuf.core.CircleResult.prototype.setRadius = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional Vector3d center = 2;
 * @return {?proto.vertexvis.protobuf.core.Vector3d}
 */
proto.vertexvis.protobuf.core.CircleResult.prototype.getCenter = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3d} */ (
    jspb.Message.getWrapperField(this, core_protos_geometry_pb.Vector3d, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.CircleResult} returns this
*/
proto.vertexvis.protobuf.core.CircleResult.prototype.setCenter = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.CircleResult} returns this
 */
proto.vertexvis.protobuf.core.CircleResult.prototype.clearCenter = function() {
  return this.setCenter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.CircleResult.prototype.hasCenter = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Vector3d axis = 3;
 * @return {?proto.vertexvis.protobuf.core.Vector3d}
 */
proto.vertexvis.protobuf.core.CircleResult.prototype.getAxis = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3d} */ (
    jspb.Message.getWrapperField(this, core_protos_geometry_pb.Vector3d, 3));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.CircleResult} returns this
*/
proto.vertexvis.protobuf.core.CircleResult.prototype.setAxis = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.CircleResult} returns this
 */
proto.vertexvis.protobuf.core.CircleResult.prototype.clearAxis = function() {
  return this.setAxis(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.CircleResult.prototype.hasAxis = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.EllipseResult.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.EllipseResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.EllipseResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.EllipseResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    radiusMin: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    radiusMax: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    center: (f = msg.getCenter()) && core_protos_geometry_pb.Vector3d.toObject(includeInstance, f),
    axis: (f = msg.getAxis()) && core_protos_geometry_pb.Vector3d.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.EllipseResult}
 */
proto.vertexvis.protobuf.core.EllipseResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.EllipseResult;
  return proto.vertexvis.protobuf.core.EllipseResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.EllipseResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.EllipseResult}
 */
proto.vertexvis.protobuf.core.EllipseResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRadiusMin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRadiusMax(value);
      break;
    case 3:
      var value = new core_protos_geometry_pb.Vector3d;
      reader.readMessage(value,core_protos_geometry_pb.Vector3d.deserializeBinaryFromReader);
      msg.setCenter(value);
      break;
    case 4:
      var value = new core_protos_geometry_pb.Vector3d;
      reader.readMessage(value,core_protos_geometry_pb.Vector3d.deserializeBinaryFromReader);
      msg.setAxis(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.EllipseResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.EllipseResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.EllipseResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.EllipseResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRadiusMin();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getRadiusMax();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getCenter();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      core_protos_geometry_pb.Vector3d.serializeBinaryToWriter
    );
  }
  f = message.getAxis();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      core_protos_geometry_pb.Vector3d.serializeBinaryToWriter
    );
  }
};


/**
 * optional double radius_min = 1;
 * @return {number}
 */
proto.vertexvis.protobuf.core.EllipseResult.prototype.getRadiusMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.EllipseResult} returns this
 */
proto.vertexvis.protobuf.core.EllipseResult.prototype.setRadiusMin = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double radius_max = 2;
 * @return {number}
 */
proto.vertexvis.protobuf.core.EllipseResult.prototype.getRadiusMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.EllipseResult} returns this
 */
proto.vertexvis.protobuf.core.EllipseResult.prototype.setRadiusMax = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional Vector3d center = 3;
 * @return {?proto.vertexvis.protobuf.core.Vector3d}
 */
proto.vertexvis.protobuf.core.EllipseResult.prototype.getCenter = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3d} */ (
    jspb.Message.getWrapperField(this, core_protos_geometry_pb.Vector3d, 3));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.EllipseResult} returns this
*/
proto.vertexvis.protobuf.core.EllipseResult.prototype.setCenter = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.EllipseResult} returns this
 */
proto.vertexvis.protobuf.core.EllipseResult.prototype.clearCenter = function() {
  return this.setCenter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.EllipseResult.prototype.hasCenter = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Vector3d axis = 4;
 * @return {?proto.vertexvis.protobuf.core.Vector3d}
 */
proto.vertexvis.protobuf.core.EllipseResult.prototype.getAxis = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3d} */ (
    jspb.Message.getWrapperField(this, core_protos_geometry_pb.Vector3d, 4));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.EllipseResult} returns this
*/
proto.vertexvis.protobuf.core.EllipseResult.prototype.setAxis = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.EllipseResult} returns this
 */
proto.vertexvis.protobuf.core.EllipseResult.prototype.clearAxis = function() {
  return this.setAxis(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.EllipseResult.prototype.hasAxis = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.vertexvis.protobuf.core.MeasurementResult.oneofGroups_ = [[1,2,3,4,5,6,7]];

/**
 * @enum {number}
 */
proto.vertexvis.protobuf.core.MeasurementResult.DetailsCase = {
  DETAILS_NOT_SET: 0,
  PLANAR_DISTANCE: 1,
  PLANAR_ANGLE: 2,
  MINIMUM_DISTANCE: 3,
  TOTAL_SURFACE_AREA: 4,
  TOTAL_LENGTH: 5,
  CIRCLE: 6,
  ELLIPSE: 7
};

/**
 * @return {proto.vertexvis.protobuf.core.MeasurementResult.DetailsCase}
 */
proto.vertexvis.protobuf.core.MeasurementResult.prototype.getDetailsCase = function() {
  return /** @type {proto.vertexvis.protobuf.core.MeasurementResult.DetailsCase} */(jspb.Message.computeOneofCase(this, proto.vertexvis.protobuf.core.MeasurementResult.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.MeasurementResult.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.MeasurementResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.MeasurementResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.MeasurementResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    planarDistance: (f = msg.getPlanarDistance()) && proto.vertexvis.protobuf.core.PlanarDistanceResult.toObject(includeInstance, f),
    planarAngle: (f = msg.getPlanarAngle()) && proto.vertexvis.protobuf.core.PlanarAngleResult.toObject(includeInstance, f),
    minimumDistance: (f = msg.getMinimumDistance()) && proto.vertexvis.protobuf.core.MinimumDistanceResult.toObject(includeInstance, f),
    totalSurfaceArea: (f = msg.getTotalSurfaceArea()) && proto.vertexvis.protobuf.core.SurfaceAreaResult.toObject(includeInstance, f),
    totalLength: (f = msg.getTotalLength()) && proto.vertexvis.protobuf.core.LengthResult.toObject(includeInstance, f),
    circle: (f = msg.getCircle()) && proto.vertexvis.protobuf.core.CircleResult.toObject(includeInstance, f),
    ellipse: (f = msg.getEllipse()) && proto.vertexvis.protobuf.core.EllipseResult.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.MeasurementResult}
 */
proto.vertexvis.protobuf.core.MeasurementResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.MeasurementResult;
  return proto.vertexvis.protobuf.core.MeasurementResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.MeasurementResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.MeasurementResult}
 */
proto.vertexvis.protobuf.core.MeasurementResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.core.PlanarDistanceResult;
      reader.readMessage(value,proto.vertexvis.protobuf.core.PlanarDistanceResult.deserializeBinaryFromReader);
      msg.setPlanarDistance(value);
      break;
    case 2:
      var value = new proto.vertexvis.protobuf.core.PlanarAngleResult;
      reader.readMessage(value,proto.vertexvis.protobuf.core.PlanarAngleResult.deserializeBinaryFromReader);
      msg.setPlanarAngle(value);
      break;
    case 3:
      var value = new proto.vertexvis.protobuf.core.MinimumDistanceResult;
      reader.readMessage(value,proto.vertexvis.protobuf.core.MinimumDistanceResult.deserializeBinaryFromReader);
      msg.setMinimumDistance(value);
      break;
    case 4:
      var value = new proto.vertexvis.protobuf.core.SurfaceAreaResult;
      reader.readMessage(value,proto.vertexvis.protobuf.core.SurfaceAreaResult.deserializeBinaryFromReader);
      msg.setTotalSurfaceArea(value);
      break;
    case 5:
      var value = new proto.vertexvis.protobuf.core.LengthResult;
      reader.readMessage(value,proto.vertexvis.protobuf.core.LengthResult.deserializeBinaryFromReader);
      msg.setTotalLength(value);
      break;
    case 6:
      var value = new proto.vertexvis.protobuf.core.CircleResult;
      reader.readMessage(value,proto.vertexvis.protobuf.core.CircleResult.deserializeBinaryFromReader);
      msg.setCircle(value);
      break;
    case 7:
      var value = new proto.vertexvis.protobuf.core.EllipseResult;
      reader.readMessage(value,proto.vertexvis.protobuf.core.EllipseResult.deserializeBinaryFromReader);
      msg.setEllipse(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.MeasurementResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.MeasurementResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.MeasurementResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.MeasurementResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlanarDistance();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vertexvis.protobuf.core.PlanarDistanceResult.serializeBinaryToWriter
    );
  }
  f = message.getPlanarAngle();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vertexvis.protobuf.core.PlanarAngleResult.serializeBinaryToWriter
    );
  }
  f = message.getMinimumDistance();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.vertexvis.protobuf.core.MinimumDistanceResult.serializeBinaryToWriter
    );
  }
  f = message.getTotalSurfaceArea();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.vertexvis.protobuf.core.SurfaceAreaResult.serializeBinaryToWriter
    );
  }
  f = message.getTotalLength();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.vertexvis.protobuf.core.LengthResult.serializeBinaryToWriter
    );
  }
  f = message.getCircle();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.vertexvis.protobuf.core.CircleResult.serializeBinaryToWriter
    );
  }
  f = message.getEllipse();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.vertexvis.protobuf.core.EllipseResult.serializeBinaryToWriter
    );
  }
};


/**
 * optional PlanarDistanceResult planar_distance = 1;
 * @return {?proto.vertexvis.protobuf.core.PlanarDistanceResult}
 */
proto.vertexvis.protobuf.core.MeasurementResult.prototype.getPlanarDistance = function() {
  return /** @type{?proto.vertexvis.protobuf.core.PlanarDistanceResult} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.PlanarDistanceResult, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.PlanarDistanceResult|undefined} value
 * @return {!proto.vertexvis.protobuf.core.MeasurementResult} returns this
*/
proto.vertexvis.protobuf.core.MeasurementResult.prototype.setPlanarDistance = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.vertexvis.protobuf.core.MeasurementResult.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.MeasurementResult} returns this
 */
proto.vertexvis.protobuf.core.MeasurementResult.prototype.clearPlanarDistance = function() {
  return this.setPlanarDistance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.MeasurementResult.prototype.hasPlanarDistance = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PlanarAngleResult planar_angle = 2;
 * @return {?proto.vertexvis.protobuf.core.PlanarAngleResult}
 */
proto.vertexvis.protobuf.core.MeasurementResult.prototype.getPlanarAngle = function() {
  return /** @type{?proto.vertexvis.protobuf.core.PlanarAngleResult} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.PlanarAngleResult, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.PlanarAngleResult|undefined} value
 * @return {!proto.vertexvis.protobuf.core.MeasurementResult} returns this
*/
proto.vertexvis.protobuf.core.MeasurementResult.prototype.setPlanarAngle = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.vertexvis.protobuf.core.MeasurementResult.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.MeasurementResult} returns this
 */
proto.vertexvis.protobuf.core.MeasurementResult.prototype.clearPlanarAngle = function() {
  return this.setPlanarAngle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.MeasurementResult.prototype.hasPlanarAngle = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional MinimumDistanceResult minimum_distance = 3;
 * @return {?proto.vertexvis.protobuf.core.MinimumDistanceResult}
 */
proto.vertexvis.protobuf.core.MeasurementResult.prototype.getMinimumDistance = function() {
  return /** @type{?proto.vertexvis.protobuf.core.MinimumDistanceResult} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.MinimumDistanceResult, 3));
};


/**
 * @param {?proto.vertexvis.protobuf.core.MinimumDistanceResult|undefined} value
 * @return {!proto.vertexvis.protobuf.core.MeasurementResult} returns this
*/
proto.vertexvis.protobuf.core.MeasurementResult.prototype.setMinimumDistance = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.vertexvis.protobuf.core.MeasurementResult.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.MeasurementResult} returns this
 */
proto.vertexvis.protobuf.core.MeasurementResult.prototype.clearMinimumDistance = function() {
  return this.setMinimumDistance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.MeasurementResult.prototype.hasMinimumDistance = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional SurfaceAreaResult total_surface_area = 4;
 * @return {?proto.vertexvis.protobuf.core.SurfaceAreaResult}
 */
proto.vertexvis.protobuf.core.MeasurementResult.prototype.getTotalSurfaceArea = function() {
  return /** @type{?proto.vertexvis.protobuf.core.SurfaceAreaResult} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.SurfaceAreaResult, 4));
};


/**
 * @param {?proto.vertexvis.protobuf.core.SurfaceAreaResult|undefined} value
 * @return {!proto.vertexvis.protobuf.core.MeasurementResult} returns this
*/
proto.vertexvis.protobuf.core.MeasurementResult.prototype.setTotalSurfaceArea = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.vertexvis.protobuf.core.MeasurementResult.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.MeasurementResult} returns this
 */
proto.vertexvis.protobuf.core.MeasurementResult.prototype.clearTotalSurfaceArea = function() {
  return this.setTotalSurfaceArea(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.MeasurementResult.prototype.hasTotalSurfaceArea = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional LengthResult total_length = 5;
 * @return {?proto.vertexvis.protobuf.core.LengthResult}
 */
proto.vertexvis.protobuf.core.MeasurementResult.prototype.getTotalLength = function() {
  return /** @type{?proto.vertexvis.protobuf.core.LengthResult} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.LengthResult, 5));
};


/**
 * @param {?proto.vertexvis.protobuf.core.LengthResult|undefined} value
 * @return {!proto.vertexvis.protobuf.core.MeasurementResult} returns this
*/
proto.vertexvis.protobuf.core.MeasurementResult.prototype.setTotalLength = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.vertexvis.protobuf.core.MeasurementResult.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.MeasurementResult} returns this
 */
proto.vertexvis.protobuf.core.MeasurementResult.prototype.clearTotalLength = function() {
  return this.setTotalLength(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.MeasurementResult.prototype.hasTotalLength = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional CircleResult circle = 6;
 * @return {?proto.vertexvis.protobuf.core.CircleResult}
 */
proto.vertexvis.protobuf.core.MeasurementResult.prototype.getCircle = function() {
  return /** @type{?proto.vertexvis.protobuf.core.CircleResult} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.CircleResult, 6));
};


/**
 * @param {?proto.vertexvis.protobuf.core.CircleResult|undefined} value
 * @return {!proto.vertexvis.protobuf.core.MeasurementResult} returns this
*/
proto.vertexvis.protobuf.core.MeasurementResult.prototype.setCircle = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.vertexvis.protobuf.core.MeasurementResult.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.MeasurementResult} returns this
 */
proto.vertexvis.protobuf.core.MeasurementResult.prototype.clearCircle = function() {
  return this.setCircle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.MeasurementResult.prototype.hasCircle = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional EllipseResult ellipse = 7;
 * @return {?proto.vertexvis.protobuf.core.EllipseResult}
 */
proto.vertexvis.protobuf.core.MeasurementResult.prototype.getEllipse = function() {
  return /** @type{?proto.vertexvis.protobuf.core.EllipseResult} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.EllipseResult, 7));
};


/**
 * @param {?proto.vertexvis.protobuf.core.EllipseResult|undefined} value
 * @return {!proto.vertexvis.protobuf.core.MeasurementResult} returns this
*/
proto.vertexvis.protobuf.core.MeasurementResult.prototype.setEllipse = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.vertexvis.protobuf.core.MeasurementResult.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.MeasurementResult} returns this
 */
proto.vertexvis.protobuf.core.MeasurementResult.prototype.clearEllipse = function() {
  return this.setEllipse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.MeasurementResult.prototype.hasEllipse = function() {
  return jspb.Message.getField(this, 7) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vertexvis.protobuf.core.MeasurementOutcome.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.MeasurementOutcome.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.MeasurementOutcome.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.MeasurementOutcome} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.MeasurementOutcome.toObject = function(includeInstance, msg) {
  var f, obj = {
    resultsList: jspb.Message.toObjectList(msg.getResultsList(),
    proto.vertexvis.protobuf.core.MeasurementResult.toObject, includeInstance),
    isApproximate: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.MeasurementOutcome}
 */
proto.vertexvis.protobuf.core.MeasurementOutcome.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.MeasurementOutcome;
  return proto.vertexvis.protobuf.core.MeasurementOutcome.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.MeasurementOutcome} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.MeasurementOutcome}
 */
proto.vertexvis.protobuf.core.MeasurementOutcome.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.core.MeasurementResult;
      reader.readMessage(value,proto.vertexvis.protobuf.core.MeasurementResult.deserializeBinaryFromReader);
      msg.addResults(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsApproximate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.MeasurementOutcome.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.MeasurementOutcome.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.MeasurementOutcome} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.MeasurementOutcome.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResultsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.vertexvis.protobuf.core.MeasurementResult.serializeBinaryToWriter
    );
  }
  f = message.getIsApproximate();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * repeated MeasurementResult results = 1;
 * @return {!Array<!proto.vertexvis.protobuf.core.MeasurementResult>}
 */
proto.vertexvis.protobuf.core.MeasurementOutcome.prototype.getResultsList = function() {
  return /** @type{!Array<!proto.vertexvis.protobuf.core.MeasurementResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.vertexvis.protobuf.core.MeasurementResult, 1));
};


/**
 * @param {!Array<!proto.vertexvis.protobuf.core.MeasurementResult>} value
 * @return {!proto.vertexvis.protobuf.core.MeasurementOutcome} returns this
*/
proto.vertexvis.protobuf.core.MeasurementOutcome.prototype.setResultsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.vertexvis.protobuf.core.MeasurementResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vertexvis.protobuf.core.MeasurementResult}
 */
proto.vertexvis.protobuf.core.MeasurementOutcome.prototype.addResults = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.vertexvis.protobuf.core.MeasurementResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vertexvis.protobuf.core.MeasurementOutcome} returns this
 */
proto.vertexvis.protobuf.core.MeasurementOutcome.prototype.clearResultsList = function() {
  return this.setResultsList([]);
};


/**
 * optional bool is_approximate = 2;
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.MeasurementOutcome.prototype.getIsApproximate = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vertexvis.protobuf.core.MeasurementOutcome} returns this
 */
proto.vertexvis.protobuf.core.MeasurementOutcome.prototype.setIsApproximate = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


goog.object.extend(exports, proto.vertexvis.protobuf.core);
